module.exports = __webpack_public_path__ + "static/media/29BDOS5.570ce01f.jpg";